<template>
  <div>
    <div v-if="this.$store.state.nodes.length">
      <ul>
        <li v-for="(client, index) in filterClients" :key="`client-${index}`">
          <node-card :node="client" :index="index"></node-card>
        </li>
      </ul>
    </div>

    <div v-else class="has-text-centered" style="color: #aaa; margin-top: calc(134px + 2rem)">
      <span style="
          background: #eeeff7;
          padding: 0 0.8rem;
          position: relative;
          z-index: 2;
        ">{{ $t("nodes.nonode") }}</span>
      <div style="position: relative; top: -0.5rem; margin: 0 1rem; z-index: 1"></div>
    </div>
    <div v-if="this.$store.state.nodes.length < 2">
      <p style="color: red">{{ $t("nodes.atleast2") }}</p>
    </div>
  </div>
</template>

<script>
import NodeCard from "./card/nodecard.vue"
export default {
  name: "device",
  components: {
    NodeCard,
    // AppCard,
  },
  data() {
    return {
      clients: [],
      popupState: {
        display: false,
        data: {},
        isLoading: false,
      },
    }
  },

  beforeMount() {
    this.loadClients()
  },

  mounted() { },
  computed: {
    filterClients() {

      if (this.$store.state.keyword?.length > 0) {
        return this.$store.state.nodes.filter(
          (node) =>
            node.name.indexOf(this.$store.state.keyword) != -1 ||
            node.version.indexOf(this.$store.state.keyword) != -1 ||
            node.os.indexOf(this.$store.state.keyword) != -1 ||
            node.ip.indexOf(this.$store.state.keyword) != -1
        )
      } else {
        return this.$store.state.nodes
      }
    },
  },
  methods: {
    loadClients: async function () {
      window.debugLog("this.$store.state.nodes.length", this.$store.state.nodes)
      // TODO: support both debug and release url
      await this.$initDataOnce()
    },
  },

  watch: {},
}
</script>


